  export const getColour = (key: string, data: boolean = false) => {
    switch (key) {
      case "partners":
        return data ? "#004a59" : "#abe9f5";
      case "consumer":
      case "onlinebrands":
        return data ? "#800055" : "#f6a6db";
      case "p2p":
        return data ? "#ffaa00" : "#fae3b6";
      case "checkout- moneygram":
        return "rgb(228, 35, 19)"
      case "checkout- ain":
        return "rgb(149, 193, 31)";  
      case "digicel":
        return "#e4002b"
      case "b2b":
        return data ? "#599eff" : "#e0e9f8";
      case "checkout- western union":
      case "checkout- western union eu":
      case "whitelabel":
        return "rgb(0,0,0)";
    }
    return "#004a59";
  };